




















































































import { Component, Prop, Vue } from "vue-property-decorator";
import ColorPicker from "@/commonComponents/colorPicker/colorPicker.vue";

import * as def from "@/definitions";

import { Layer } from "@/model/document2/page/surface/design/layer/layer";
import { TableLayer } from "@/model/document2/page/surface/design/layer/tableLayer";

import { ColorConstruct } from "@/utilityModels/colorConstruct";

// import CustomInput from '@/commonComponents/customInput/customInput.vue';

import ValueEdit from "@/commonComponents/valueEdit/valueEdit.vue";

import ColorSelector from "@/commonComponents/colorSelector/colorSelector.vue";
import AdjustedBalloon from '@/commonComponents/adjustedBalloon/adjustedBalloon.vue';

// ボタン
import ArrowDown from "../resources/arrowDown.vue";
import ArrowRight from "../resources/arrowRight.vue";
import CheckBoxOn from "../resources/checkBoxOn.vue";

import { ResourceHelper } from "@/helper/resourceHelper"

@Component({
  components: {
    ColorPicker,
    ValueEdit,
    ColorSelector,
    AdjustedBalloon,
    ArrowDown,
    ArrowRight,
    CheckBoxOn
  }
})
export default class TableAll extends Vue {
    @Prop() private layer!: TableLayer;

    //↓↓↓↓↓開閉のアニメーション↓↓↓↓↓
    //こいつはpropsでもらいたい
    openStatus = {
        opend: true
    };

    tableAllContentsOpenAnimate = false;
    tableAllContentsCloseAnimate = false;

    open() {
        if (this.openStatus.opend) {
        this.tableAllContentsCloseAnimate = true;
        setTimeout(() => {
            this.tableAllContentsCloseAnimate = false;
            this.tableAllContentsOpenAnimate = false;
            this.openStatus.opend = false;
        }, 200);
        } else {
            this.openStatus.opend = true;
            this.tableAllContentsOpenAnimate = true;
            setTimeout(() => {
                this.tableAllContentsOpenAnimate = false;
            }, 250);
        }
    }
    //↑↑↑↑↑開閉のアニメーション↑↑↑↑↑

    //↓↓↓↓↓カラーピッカー表示非表示↓↓↓↓↓
    //こいつはpropsでいらない
    isStrokeColorPickerVisible = false;
    showStrokeColorPicker() {
        this.isStrokeColorPickerVisible = true;
    }
    closeStrokeColorPicker() {
        this.isStrokeColorPickerVisible = false;
    }
    isBackgroundColorPickerVisible = false;
    showBackgroundColorPicker() {
        this.isBackgroundColorPickerVisible = true;
    }
    closeBackgroundColorPicker() {
        this.isBackgroundColorPickerVisible = false;
    }
    //↑↑↑↑↑カラーピッカー表示非表示↑↑↑↑↑

    //↓↓↓↓↓色↓↓↓↓↓

    private getEqualCellColor(propertyName) : ColorConstruct | null
    {
        var vals = new Array();
        for(var r = 0; r < this.layer.row; ++r)
        {
            for(var c = 0; c < this.layer.column; ++c)
            {
                var val : ColorConstruct = this.layer.getCellInfo(r, c)[propertyName];
                if(vals.length > 0)
                {
                    if(!val.equals(vals[vals.length - 1]))
                    {
                        // 前の値と等しくない
                        return null;
                    }
                }
                vals.push(val);
            }
        }

        return vals.length > 0 ? vals[0] : null;
    }

    get strokeColor(): ColorConstruct 
    {
        return this.layer.strokeColor;
    }

    get strokeColorStyle() {
        return {
            background: this.strokeColor.hex
        };
    }

    get backgroundColor()
    {
        var color = this.getEqualCellColor("backgroundColor");
        return color != null ? color : new ColorConstruct(255, 255, 255);
    }

    get backgroundColorStyle()
    {
        var color = this.getEqualCellColor("backgroundColor");
        return color != null ? color.hex : "rgba(0, 0, 0, 0)"
    }

    // 色変更中
    private onChangingStrokeColor(color) {
        this.changeLayerProperty(color, "strokeColor");
    }
    // 色変更完了
    private onChangedStrokeColor(color) {
        this.changeLayerProperty(color, "strokeColor");
    }

    //↑↑↑↑↑色↑↑↑↑↑

    //*** 線幅 ***//
    private get strokeWidth() 
    {
        return this.layer.strokeWidth;
    }

    // セル固有の値変更
    private onChangingCellValue(value, tag : string)
    {
        this.changeCellInfo(value, tag, false);
    }

    private onChangedCellValue(value, tag : string)
    {
        this.changeCellInfo(value, tag, true);
    }

    private changingLayerValue(value, tag)
    {
        this.changeLayerProperty(value, tag, false);
    }

    private changedLayerValue(value, tag)
    {
        this.changeLayerProperty(value, tag, true);
    }

    // セル追加
    private clickAddCell(direction : number)
    {
        this.$emit("doCommand", "addTableCell", { layer : this.layer, direction : direction });
    }

    // セル削除
    private clickDeleteCell(isDeleteRow : boolean, isDeleteColumn : boolean)
    {
        this.$emit("doCommand", "deleteTableCell", { layer : this.layer, isDeleteRow : isDeleteRow, isDeleteColumn : isDeleteColumn });
    }

    private changeLayerProperty(
        value: any,
        propertyName: string,
        isFinish: boolean = false,
        isOnce: boolean = false
    ) {
        this.$emit("doCommand", "changeLayerProperty", {
        layer: this.layer,
        propertyName: propertyName,
        value: value,
        isFinish: isFinish,
        isOnce: isOnce
        });
    }

    private changeCellInfo(value : any, propertyName : string, isFinish : boolean = false)
    {
        this.$emit("doCommand", "changeAllTableCellInfo", { layer : this.layer, propertyName : propertyName, value : value, isFinish : isFinish });
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigUnderLineColor(){
        var style = {
            backgroundColor : this.userConfigColor
        };
        return style;
    }
    private get userConfigFontColor(){
        var style = {
            color : this.userConfigColor
        };
        return style;
    }

    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }

private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }
}
